import { Turbo } from "@hotwired/turbo-rails"
import 'alpine-turbo-drive-adapter'

import './application'

// Turbo가 활성화된 영역을 벗어날 때 처리
document.addEventListener('turbo:before-visit', (event) => {
  const url = new URL(event.detail.url)
  const path = url.pathname

  // market이나 spaces가 아닌 경로로 이동 시 일반 페이지 로드
  if (!path.includes('/market/') && !path.match(/\/spaces\/[^\/]+/)) {
    event.preventDefault()
    // Turbo 세션 중지
    Turbo.session.stop()
    // 일반 페이지 이동
    window.location.href = event.detail.url
  }
})

// 페이지 언로드 시 Turbo 정리
window.addEventListener('beforeunload', () => {
  // 파일을 받는 폼 제출도 beforeunload 를 부르지만, 응답이 다운로드면 페이지는 그대로 남는다.
  // 그때 Turbo 를 끄면 다운로드 뒤의 화면 갱신(broadcast_refresh)을 받지 못한다(order_download_controller.js).
  if (document.documentElement.dataset.fileDownloadPending) return

  if (window.Turbo) {
    Turbo.session.stop()
  }
})
